<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.1678 2.58588L8.16785 10.5859C7.3868 11.3669 7.3868 12.6333 8.16785 13.4143L16.1678 21.4143L16.1678 18.5859L9.58206 12.0001L16.1678 5.41431L16.1678 2.58588Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'MissionLeftIcon',
  props: {
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
})
</script>
